export const ASSET_FAVORITES_GET_DATA = 'ASSET_FAVORITES_GET_DATA'
export const ASSET_FAVORITES_GET_DATA_SUCCESS = 'ASSET_FAVORITES_GET_DATA_SUCCESS'
export const ASSET_FAVORITES_GET_DATA_FAILURE = 'ASSET_FAVORITES_GET_DATA_FAILURE'
export const ASSET_FAVORITES_EMPTY = 'ASSET_FAVORITES_EMPTY'

export const ASSET_FAVORITES_SET_SELECT = 'ASSET_FAVORITES_SET_SELECT'
export const ASSET_FAVORITES_UNSET_SELECT = 'ASSET_FAVORITES_UNSET_SELECT'

export const ASSET_FAVORITES_ACTIVEVIEW = 'ASSET_FAVORITES_ACTIVEVIEW'

export const ASSET_FAVORITES_EDIT_SELECT = 'ASSET_FAVORITES_EDIT_SELECT'
export const ASSET_FAVORITES_EDIT_UNSET_SELECT = 'ASSET_FAVORITES_EDIT_UNSET_SELECT'
export const ASSET_FAVORITES_EDIT = 'ASSET_FAVORITES_EDIT'
export const ASSET_FAVORITES_EDIT_SUCCESS = 'ASSET_FAVORITES_EDIT_SUCCESS'
export const ASSET_FAVORITES_EDIT_FAILURE = 'ASSET_FAVORITES_EDIT_FAILURE'

export const ASSET_FAVORITES_DELETE = 'ASSET_FAVORITES_DELETE'
export const ASSET_FAVORITES_DELETE_SUCCESS = 'ASSET_FAVORITES_DELETE_SUCCESS'
export const ASSET_FAVORITES_DELETE_FAILURE = 'ASSET_FAVORITES_DELETE_FAILURE'

export const ASSET_FAVORITES_EXPAND_SELECT = 'ASSET_FAVORITES_EXPAND_SELECT'
export const ASSET_FAVORITES_EXPAND_UNSET_SELECT = 'ASSET_FAVORITES_EXPAND_UNSET_SELECT'

export const ASSET_FAVORITES_SHARE_SELECT = 'ASSET_FAVORITES_SHARE_SELECT'
export const ASSET_FAVORITES_SHARE_UNSET_SELECT = 'ASSET_FAVORITES_SHARE_UNSET_SELECT'

export const ASSET_FAVORITES_ADD = 'ASSET_FAVORITES_ADD'
export const ASSET_FAVORITES_ADD_SUCCESS = 'ASSET_FAVORITES_ADD_SUCCESS'
export const ASSET_FAVORITES_ADD_FAILURE = 'ASSET_FAVORITES_ADD_FAILURE'

export const ASSET_FAVORITES_REMOVE = 'ASSET_FAVORITES_REMOVE'
export const ASSET_FAVORITES_REMOVE_SUCCESS = 'ASSET_FAVORITES_REMOVE_SUCCESS'
export const ASSET_FAVORITES_REMOVE_FAILURE = 'ASSET_FAVORITES_REMOVE_FAILURE'

export const ASSET_FAVORITES_MOVE = 'ASSET_FAVORITES_MOVE'
export const ASSET_FAVORITES_MOVE_SUCCESS = 'ASSET_FAVORITES_MOVE_SUCCESS'
export const ASSET_FAVORITES_MOVE_FAILURE = 'ASSET_FAVORITES_MOVE_FAILURE'

export const ASSET_FAVORITES_CHECK_SELECT = 'ASSET_FAVORITES_CHECK_SELECT'
export const ASSET_FAVORITES_UNCHECK_SELECT = 'ASSET_FAVORITES_UNCHECK_SELECT'

export const MULTIPLE_FAVORITES_OPTIONS_ACTIVATE = 'MULTIPLE_FAVORITES_OPTIONS_ACTIVATE'
export const MULTIPLE_FAVORITES_OPTIONS_DEACTIVATE = 'MULTIPLE_FAVORITES_OPTIONS_DEACTIVATE'
export const MULTIPLE_FAVORITES_OPTIONS_DONE = 'MULTIPLE_FAVORITES_OPTIONS_DONE'

export const ASSET_FAVORITES_UPDATE_FROM_PERMISSION = 'ASSET_FAVORITES_UPDATE_FROM_PERMISSION'

export const ASSETS_FAVORITES_MULTI_DELETE = 'ASSETS_FAVORITES_MULTI_DELETE'
export const ASSETS_FAVORITES_MULTI_DELETE_SUCCESS = 'ASSETS_FAVORITES_MULTI_DELETE_SUCCESS'
export const ASSETS_FAVORITES_MULTI_DELETE_FAILURE = 'ASSETS_FAVORITES_MULTI_DELETE_FAILURE'

export const ASSETS_FAVORITES_MULTI_MOVE = 'ASSETS_FAVORITES_MULTI_MOVE'
export const ASSETS_FAVORITES_MULTI_MOVE_SUCCESS = 'ASSETS_FAVORITES_MULTI_MOVE_SUCCESS'
export const ASSETS_FAVORITES_MULTI_MOVE_FAILURE = 'ASSETS_FAVORITES_MULTI_MOVE_FAILURE'

export const ASSET_FAVORITES_MULTI_ADD = 'ASSET_FAVORITES_MULTI_ADD'
export const ASSET_FAVORITES_MULTI_ADD_SUCCESS = 'ASSET_FAVORITES_MULTI_ADD_SUCCESS'
export const ASSET_FAVORITES_MULTI_ADD_FAILURE = 'ASSET_FAVORITES_MULTI_ADD_FAILURE'

export const ASSET_FAVORITES_MULTI_REMOVE = 'ASSET_FAVORITES_MULTI_REMOVE'
export const ASSET_FAVORITES_MULTI_REMOVE_SUCCESS = 'ASSET_FAVORITES_MULTI_REMOVE_SUCCESS'
export const ASSET_FAVORITES_MULTI_REMOVE_FAILURE = 'ASSET_FAVORITES_MULTI_REMOVE_FAILURE'


